import CloseIcon from "@mui/icons-material/Close";
import { convertFontToSpan } from "../../../utils/services";
import Placeholder from "../../../common/placeholder/Placeholder";
import { Modal, Box, Typography, Grid, Button, IconButton } from "@mui/material";
import FroalaWithoutDropdown from "../../../common/froalaHtmlEditor/FroalaWithoutDropdown";

const EditCoverPage = ({ REPORT_SETTING_URL, editCoverModal, CloseCoverModal, editorContent, setEditorContent, sendSettings, editorRef }) => {
    const froalaConfig = {
        imagePaste: true,
        spellCheck: true,
        heightMin: 350,
        heightMax: 400,
        autogrow: false,
        fontFamily: {
            'Arial': 'Arial',
            'Georgia': 'Georgia',
            'Impact': 'Impact',
            'Tahoma': 'Tahoma',
            'Times New Roman': 'Times New Roman',
            'Verdana': 'Verdana',
        },
        pluginsEnabled: ["wordPaste",
            "spellChecker",
            "codeBeautifier",
            "fontFamily",
            "fontSize",
            "colors",
            "align",
            "lists",
            "image",
            "lineHeight",
            "link",
            "table",
        ],
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        fontSize: ["8", "9", "10", "11", "12", "14", "16", "18", "20", "24", "28", "30", "32", "34", "36", "48", "60"],
        imageUploadURL: `${REPORT_SETTING_URL}/upload-media`,
        imageUploadMethod: 'POST',
        imageUploadParam: 'media_file',
        imageStyles: { 'fr-rounded': 'Rounded', 'fr-bordered': 'Bordered'},
        requestHeaders: { "company-key": sessionStorage.getItem("company-key") },
        events: {
            'image.uploaded': function (response) {
                console.log('Image uploaded', response);
            },
            'image.inserted': function ($img, response) {
                console.log('Image inserted', $img, response);
            },
            'image.error': function (error, response) {
                console.error('Image upload failed', error, response);
            },
        },
        toolbarButtons: {
            moreText: { buttons: ['bold', 'italic', 'underline', '|', 'fontFamily', 'fontSize', 'textColor', 'clearFormatting'], align: 'left', buttonsVisible: 5 },
            moreParagraph: { buttons: ['|', 'formatOLSimple', 'formatUL', 'alignLeft', 'alignCenter', 'alignRight'], align: 'left', buttonsVisible: 3 },
            moreRich: { buttons: ['|', "insertLink", 'insertImage', 'insertTable'], align: "left", buttonsVisible: 3 },
            moreMisc: { buttons: ['undo', 'redo', 'selectAll', 'html',], align: 'right', buttonsVisible: 0 }
        },
    }

    const handleChange = (name, content) => {
        setEditorContent((prevState) => ({ ...prevState, innerHTML: content }));
    };

    return <Modal open={editCoverModal} onClose={CloseCoverModal} className="edit-category-outer-modal" disableEnforceFocus
        disableAutoFocus>
        <Box className="edit-coverpage-modal" >
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" >
                <Typography className='ci_title' >Cover Page</Typography>
                <IconButton onClick={CloseCoverModal} >
                    <CloseIcon />
                </IconButton>
            </Box>
            {/* Body */}
            <Box className="edit-coverpage-content" >
                {/* Text Editor */}
                <Box className="coverpage-editor-column" >
                    <Typography className="edit-title" sx={{ mb: "2px" }}>COVER PAGE</Typography>
                    {/* <HtmlCommentEditor editorContent={editorContent} froalaConfig={froalaConfig} /> */}
                    <FroalaWithoutDropdown showAI={false}
                        commentData={editorContent}
                        editorData={convertFontToSpan(editorContent)}
                        editor={editorRef}
                        id={"agreement-editor"}
                        onChange={handleChange}
                        froalaConfig={froalaConfig} />
                </Box >
                {/* Placeholder List */}
                < Box className="coverpage-placeholder-column" >
                    <Typography className="edit-title">INSERT PLACEHOLDERS</Typography>
                    <Placeholder editor={editorRef} setEditorContent={setEditorContent} />
                </Box >
            </Box >
            {/* Footer */}
            <Box display="flex" justifyContent="flex-end" mt={2} >
                <Grid container spacing={2} className="inspection-filter-modal-buttons">
                    <Button variant="outlined" onClick={CloseCoverModal} className="inspection-filter-modal-buttons-cancel">Cancel</Button>
                    <Button variant="contained" className="inspection-filter-modal-buttons-apply" onClick={sendSettings}>Apply</Button>
                </Grid>
            </Box>
        </Box >
    </Modal >
}

export default EditCoverPage;
